/*
 * @Description:
 * @Author: fal
 * @Date: 2024-10-28 16:52:50
 * @FilePath: \pc.ui\src\project\router\modules\person.js
 * @LastEditTime: 2025-03-18 09:50:04
 */
export default [
  // 控制面板
  {
    path: '/personMag/index',
    name: 'personMagIndex',
    component: () => import('@/project/views/personMag/panel/index'),
    meta: {
      title: '控制面板',
    },
  },
  // 招聘管理
  {
    path: '/personMag/index/hire',
    name: 'personMagHire',
    component: () => import('@/project/views/personMag/panel/hire'),
    meta: {
      title: '招聘管理',
    },
  },
  // 发布、编辑招聘
  {
    path: '/personMag/index/updateHire',
    name: 'personMagUpdateHire',
    component: () => import('@/project/views/personMag/panel/hire/updateInfo'),
    meta: {
      title: '人才招聘',
    },
  },
  // 查看招聘人才
  {
    path: '/personMag/index/viewHire',
    name: 'personMagViewHire',
    component: () => import('@/project/views/personMag/panel/hire/viewInfo'),
    meta: {
      title: '查看人才招聘',
    },
  },
  // 公司管理
  {
    path: '/personMag/index/company',
    name: 'personMagCompany',
    component: () => import('@/project/views/personMag/panel/company'),
    meta: {
      title: '公司管理',
    },
  },
  // 人员管理
  {
    path: '/personMag/index/people',
    name: 'personMagPeople',
    component: () => import('@/project/views/personMag/panel/people'),
    meta: {
      title: '人员管理',
    },
  },
  // 项目管理
  {
    path: '/personMag/index/project',
    name: 'personMagProject',
    component: () => import('@/project/views/personMag/panel/project'),
    meta: {
      title: '项目管理',
    },
  },
  // 求职列表
  {
    path: '/personMag/index/joblist',
    name: 'personMagJoblist',
    component: () => import('@/project/views/personMag/panel/joblist'),
    meta: {
      title: '求职简历',
    },
  },
  // 简历列表
  {
    path: '/personMag/index/resume',
    name: 'personMagResume',
    component: () => import('@/project/views/personMag/panel/resume'),
    meta: {
      title: '求职简历',
    },
  },
  // 新增/编辑简历
  {
    path: '/personMag/index/updateResume',
    name: 'personMagUpdateResume',
    component: () => import('@/project/views/personMag/panel/resume/updateInfo'),
    meta: {
      title: '求职简历',
    },
  },
  // 查看简历
  {
    path: '/personMag/index/viewResume',
    name: 'personMagViewResume',
    component: () => import('@/project/views/personMag/panel/resume/viewInfo'),
    meta: {
      title: '查看简历',
    },
  },
  // 个人资料
  {
    path: '/personMag/profile',
    name: 'personMagProfile',
    component: () => import('@/project/views/personMag/myProfile/index'),
    meta: {
      title: '我的资料',
    },
  },
  // 编辑个人资料
  {
    path: '/personMag/profile/edit',
    name: 'personMagProfileEdit',
    component: () => import('@/project/views/personMag/myProfile/editProfile'),
    meta: {
      title: '我的资料',
    },
  },
  // 资质证书
  {
    path: '/personMag/profile/cert',
    name: 'personMagCert',
    component: () => import('@/project/views/personMag/myProfile/cert'),
    meta: {
      title: '资质证书',
    },
  },
  // 信息管理
  // 我的报价
  {
    path: '/personMag/infoMag/quote',
    name: 'personMagQuote',
    component: () => import('@/project/views/personMag/infoMag/quote'),
    meta: {
      title: '我的报价',
    },
  },
  // 劳务采购
  {
    path: '/personMag/infoMag/laborDemand',
    name: 'personMagLaborDemand',
    component: () => import('@/project/views/personMag/infoMag/laborDemand'),
    meta: {
      title: '劳务采购',
    },
  },
  {
    path: '/personMag/infoMag/laborQuoteList',
    name: 'personMagLaborQuoteList',
    component: () => import('@/project/views/personMag/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 材料采购发布
  {
    path: '/personMag/infoMag/material',
    name: 'personMagMaterial',
    component: () => import('@/project/views/personMag/infoMag/material'),
    meta: {
      title: '材料采购',
    },
  },
  {
    path: '/personMag/infoMag/materialQuoteList',
    name: 'personMagMaterialQuoteList',
    component: () => import('@/project/views/personMag/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 机械采购发布
  {
    path: '/personMag/infoMag/machine',
    name: 'personMagMachine',
    component: () => import('@/project/views/personMag/infoMag/machine'),
    meta: {
      title: '机械采购',
    },
  },
  {
    path: '/personMag/infoMag/machineQuoteList',
    name: 'personMagMachineQuoteList',
    component: () => import('@/project/views/personMag/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 咨询业务
  {
    path: '/personMag/infoMag/comprehensive',
    name: 'personMagComprehensive',
    component: () => import('@/project/views/personMag/infoMag/comprehensive'),
    meta: {
      title: '咨询业务',
    },
  },
  {
    path: '/personMag/infoMag/comprehensiveQuoteList',
    name: 'personMagComprehensiveQuoteList',
    component: () => import('@/project/views/personMag/infoMag/quoteList'),
    meta: {
      title: '查看报价',
    },
  },
  // 代理业务
  {
    path: '/personMag/agent',
    name: 'personMagAgent',
    component: () => import('@/project/views/personMag/agent'),
    meta: {
      title: '代理业务',
    },
  },
  // 平台推送
  {
    path: '/personMag/push',
    name: 'personMagPush',
    // component: () => import('@/project/views/personMag/push/push'),
    component: () => import('@/views/common/push/index.vue'),
    meta: {
      title: '平台推送',
    },
  },
  // 工程项目
  {
    path: '/personMag/procedure',
    name: 'personMagProcedure',
    component: () => import('@/project/views/personMag/procedure'),
    meta: {
      title: '工程项目',
    },
  },
  // 工程项目--待处理事项
  {
    path: '/personMag/procedure/matters',
    name: 'personMagMatters',
    component: () => import('@/project/views/personMag/procedure/matters'),
    meta: {
      title: '待处理事项',
    },
  },
  // 工程项目--报销记录
  {
    path: '/personMag/procedure/remRcd',
    name: 'personMagRemRcd',
    component: () => import('@/project/views/personMag/procedure/reimbursementRecords'),
    meta: {
      title: '报销记录',
    },
  },
  // 工程项目--报销详情
  {
    path: '/personMag/procedure/remDetail',
    name: 'personMagRemDetail',
    component: () => import('@/project/views/personMag/procedure/reimbursementDetails'),
    meta: {
      title: '报销详情',
    },
  },
  // 工程项目--付款记录
  {
    path: '/personMag/procedure/paymentRcd',
    name: 'personMagPaymentRcd',
    component: () => import('@/project/views/personMag/procedure/paymentRecords'),
    meta: {
      title: '付款记录',
    },
  },
  // 工程项目--付款详情
  {
    path: '/personMag/procedure/paymentDetail',
    name: 'personMagPaymentDetail',
    component: () => import('@/project/views/personMag/procedure/paymentDetails'),
    meta: {
      title: '付款详情',
    },
  },
  // 工程项目--回款记录
  {
    path: '/personMag/procedure/paymentConfirmation',
    name: 'personMagPaymentConfirmation',
    component: () => import('@/project/views/personMag/procedure/paymentConfirmation'),
    meta: {
      title: '回款记录',
    },
  },
];
